<template>
    <div>
        <section class="jumbotron text-center">
            <div class="container">
                <h1 class="jumbotron-heading">Events</h1>
                <p class="lead text-muted">API gateway path /events</p>
            </div>
        </section>
        <div class="ui container">
             <b-card>
                    <h4>
                        Filters
                        <b-badge style="float: right">
                            <i class="fa fa-filter"></i>
                        </b-badge>
                    </h4>
                    <b-card-body>
                        <label for="filter-after">After: </label>
                        <b-form-datepicker id="filter-after" v-model="after" class="mb-2"></b-form-datepicker>
                        <label for="filter-before">Before: </label>
                        <b-form-datepicker id="filter-before" v-model="before" class="mb-2"></b-form-datepicker>
                    
                        <hr />
                        <h4>Ending date</h4>
                        <label for="filter-endingAfter">After: </label>
                        <b-form-datepicker id="filter-endingAfter" v-model="endingAfter" class="mb-2"></b-form-datepicker>
                        <label for="filter-endingBefore">Before: </label>
                        <b-form-datepicker id="filter-endingBefore" v-model="endingBefore" class="mb-2"></b-form-datepicker>
                    </b-card-body>
                </b-card>
            </b-card-group>
            
            <vuetable ref="vuetable"
                :http-fetch="fetchData"
                :api-mode="true"
                :api-url="$store.getters.apiBase + resources.events"
                :fields="fields"
                
                pagination-path="pagination"
                data-path=""
                :http-options="httpOptions()"
                @vuetable:pagination-data="onPaginationData">
                <template slot="idslot" scope="props">
                    <div class="table-button-container">
                        <router-link :to="{name: 'eventDetails', params: {event_id: props.rowData.id}}">{{props.rowData.id}}</router-link>
                    </div>
                </template>
                <template slot="langslot" scope="props">
                    <i v-if="props.rowData.languages.length &gt; 1" class="fa fa-globe"></i>
                </template>
                <template slot="actions" scope="props">
                    <div class="table-button-container">
                        <button class="ui button" @click="editRow(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
                        <button class="ui basic red button" @click="deleteRow(props.rowData)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
                    </div>
                </template>
            </vuetable>
            <vuetable-pagination
                ref="pagination" @vuetable-pagination:change-page="onChangePage">
            </vuetable-pagination>
        </div>
    </div>
</template>

<style>
.pagination a.item {
    padding: 10px;
}

.pagination a.item.large {
    font-weight: bolder
}
</style>


<script>
// import Vue from "vue";
import {Vuetable, VuetablePagination} from "vuetable-2";
import axios from "axios";
import moment from "moment";

const RANGE_RGX = /^(?:items\s)?(\d+)-(\d+)\/(\d+)$/;

export default {
    name: "eventsList",
    components: {
        Vuetable,
        VuetablePagination
    },
    data: () => {
        return {
            after: null,
            before: null,
            endingAfter: null,
            endingBefore: null,
            fields: [
                {
                    name: "__sequence",
                    title: "#",
                    titleClass: "center aligned",
                    dataClass: "right aligned"
                },
                {
                    name: "__slot:langslot",
                    title: ""
                },
                {
                    name: "__slot:idslot",
                    title: "id"
                },
                {
                    name: "name",
                    callback: (_v) => {
                        return _v?_v.value: undefined;
                    }
                },
                {
                    name: "start",
                    callback: (_v) => {
                        return moment(_v, moment.ISO_8601).format("lll");
                    }
                },
                {
                    name: "end",
                    callback: (_v) => {
                        return moment(_v, moment.ISO_8601).format("lll");
                    }
                },
                {
                    name: "location.address",
                    title: "Location"
                },
                {
                    name: "tags",
                    title: "Tags",
                    callback: (_v) => {
                        return (_v||[]).join(", ");
                    }
                }
            ],
            resources: {
                events: "/events"
            },
            page: 1,
            perPage: 10,
        };
    },
    methods: {
        event(eventId) {
            this.$router.push({name: "eventDetails", params: {event_id: eventId}});
        },
        guests(eventId) {
            this.$router.push({name: "guestsList", params: {event_id: eventId}});
        },
        fetchData(resource, options) {
            if (options && options.hasOwnProperty("params")) {
                options.headers["Range"] = "items=" + (options.params.page - 1) * options.params.per_page + "-";
                options.headers["Range"] += (options.params.page - 1) * options.params.per_page + options.params.per_page - 1;
            }

            const currentPage = options.params.page;
            const perPage = options.params.per_page;

            delete options.params.page;
            delete options.params.per_page;

            if (!options.params.sort) {
                delete options.params.sort;
            }

            if (!!this.after) {
                options.params.after = moment(this.after, moment.ISO_8601).format();
            }

            if (!!this.before) {
                options.params.before = moment(this.before, moment.ISO_8601).format();
            }

            if (!!this.endingAfter) {
                options.params.endingAfter = moment(this.endingAfter, moment.ISO_8601).format();
            }

            if (!!this.endingBefore) {
                options.params.endingBefore = moment(this.endingBefore, moment.ISO_8601).format();
            }
            console.debug("options", options.params)
            return axios
                .get(resource, options)
                .then(response => {
                    let m = RANGE_RGX[Symbol.match](
                        response.headers["content-range"]
                    );

                    const from = parseInt(m[1]);
                    const to = parseInt(m[2]);
                    const total = parseInt(m[3]);

					if (!response.data) {
                    	response.data = {};
                    }
                    response.data.pagination = {
                        total: total,
                        per_page: perPage,
                        current_page: currentPage,
                        last_page: Math.ceil(total / perPage),
                        from: from,
                        to: to
                    };

                    return response;
                })
                .catch(response => {
                    console.log(response);
                });
        },

        httpOptions() {
            const _headers = {
                "Content-Type": "application/json",
                Authorization: this.$store.getters.accessToken,
                account_id: this.$store.getters.accountId
            };

            return {headers: _headers};
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        editRow(rowData) {
            alert("You clicked edit on" + JSON.stringify(rowData));
        },
        deleteRow(rowData) {
            alert("You clicked delete on" + JSON.stringify(rowData));
        }
    },
    watch: {
        after(old, value) {
            this.$refs.vuetable.refresh();
        },

        before(old, value) {
            this.$refs.vuetable.refresh();
        },

        endingAfter(old, value) {
            this.$refs.vuetable.refresh();
        },

        endingBefore(old, value) {
            this.$refs.vuetable.refresh();
        }
        /*
        events() {
            this.setPages();
        },
        page() {
            this.paginate();
        }
        */
    },
    created() {
        // this.getEvents();
    }
};
</script>